module.exports = __webpack_public_path__ + "static/img/share.0715a7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share.jpg
// module id = TmAL
// module chunks = 29